import { useMemo } from 'react';

import { VestaGraphConfig } from '~config/vestaGraphConfig';
import VestaSubgraph from '~services/subgraph/vesta';

import { useSession } from '../useSession';

export const useVestaSubgraph = () => {
  const {
    network: { networkId },
  } = useSession();

  const url = VestaGraphConfig[networkId];

  const vestaSubgraph = useMemo<VestaSubgraph>(() => new VestaSubgraph({ url, networkId }), [url, networkId]);
  return vestaSubgraph;
};
